import { useContext, useEffect, useState } from 'react'

import useApi from '@hooks/useApi';
import useLoader from '@hooks/useLoader';

import ActiveYearContext from '@context/ActiveYearContext'

const YearDropDown = () => {

    const { setYearContext, setSeasonContext, setSeasonNameContext, setActiveWeek } = useContext(ActiveYearContext)

    const [yearName, setYear] = useState('')
    const [seasonName, setSeason] = useState('')
    const [seasonId, setSeasonId] = useState('')
    const [activeWeek, setWeek] = useState('')

    const activeYearApi = useApi().activeyear
	const { fetchData } = useLoader({})

    /* Жагсаалтын дата авах функц */
    async function getDatas() {
        const {success, data} = await fetchData(activeYearApi.get())
        if(success && data) {
            setYear(data.active_lesson_year)
            setSeason(data.active_season)
            setSeasonId(data.active_lesson_season)
            setWeek(data.active_week)
        }
    }

    useEffect(() => {
        setYearContext(yearName)
        setSeasonNameContext(seasonName)
        setSeasonContext(seasonId)
        setActiveWeek(activeWeek)
    },[yearName, seasonName, seasonId, activeWeek])

    useEffect(
        () =>
        {
            getDatas()
        },
        []
    )

    return (
        <div className='d-flex flex-row align-items-center'>
            <div className='flex flex-column ms-1'>
                <p className='fw-bolder m-0'>{yearName}, {seasonName}</p>
                <p className='fw-bolder m-0'>{ activeWeek && `${activeWeek}-р долоо хоног`}</p>
            </div>
        </div>
    )
}

export default YearDropDown
